import React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        success: 'border-transparent bg-green-500/20 text-green-700 dark:text-green-400',
        
        inactive: 'border-transparent bg-red-50 text-red-500 dark:bg-red-950/30 dark:text-red-400',
        
        active: 'border-transparent bg-green-50 text-green-500 dark:bg-green-950/30 dark:text-green-400',
        
        transporter: 'border-transparent bg-blue-50 text-blue-500 dark:bg-blue-950/30 dark:text-blue-400',
        
        distributor: 'border-transparent bg-purple-50 text-purple-500 dark:bg-purple-950/30 dark:text-purple-400',
        
        admin: 'border-transparent bg-orange-50 text-orange-500 dark:bg-orange-950/30 dark:text-orange-400',
        
        scheduled: 'border-transparent bg-yellow-50 text-yellow-500 dark:bg-yellow-950/30 dark:text-yellow-400',
        
        delayed: 'border-transparent bg-red-50 text-red-500 dark:bg-red-950/30 dark:text-red-400',
        
        completed: 'border-transparent bg-green-50 text-green-500 dark:bg-green-950/30 dark:text-green-400',
        
        warning: 'border-transparent bg-yellow-50 text-yellow-500 dark:bg-yellow-950/30 dark:text-yellow-400',
        
        driver: 'border-transparent bg-indigo-50 text-indigo-500 dark:bg-indigo-950/30 dark:text-indigo-400',

        retailer: 'border-transparent bg-pink-50 text-pink-500 dark:bg-pink-950/30 dark:text-pink-400',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };